/**
 * @generated SignedSource<<044ee9ac63cbdcf0d7451749af8e8407>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EvaluationType = "TOP_PERFORMING" | "WORSE_PERFORMING" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type GetAISummaryRequest = {
  aiDateRange: string;
  brandId: string;
  evaluationType: EvaluationType;
  kpi: KPI;
};
export type AISummaryInsightQuery$variables = {
  input: GetAISummaryRequest;
  skip: boolean;
};
export type AISummaryInsightQuery$data = {
  readonly getAISummary?: {
    readonly content: string | null;
  } | null;
};
export type AISummaryInsightQuery = {
  response: AISummaryInsightQuery$data;
  variables: AISummaryInsightQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "AISummary",
        "kind": "LinkedField",
        "name": "getAISummary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AISummaryInsightQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AISummaryInsightQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a541e8a6a9dd8f84b21bc6cce2d9747a",
    "id": null,
    "metadata": {},
    "name": "AISummaryInsightQuery",
    "operationKind": "query",
    "text": "query AISummaryInsightQuery(\n  $input: GetAISummaryRequest!\n  $skip: Boolean!\n) {\n  getAISummary(input: $input) @skip(if: $skip) {\n    content\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7f003456934d3670f5708d141911a50";

export default node;
